import { render, staticRenderFns } from "./BlogsView.vue?vue&type=template&id=176c916f&"
import script from "./BlogsView.vue?vue&type=script&lang=ts&"
export * from "./BlogsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports